export default __webpack_public_path__ + "static/media/Galapagos.06a68b46.jpg";